"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Facebook = function Facebook(props) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 15,
    height: 30,
    viewBox: "0 0 15 30"
  }, props), (0, _core.jsx)("path", {
    d: "M14.415 15.78H9.892V30H3.188V15.78H0v-5.568h3.188V6.61C3.188 4.034 4.44 0 9.952 0l4.966.02v5.404h-3.603c-.592 0-1.423.289-1.423 1.518v3.276H15l-.585 5.562z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

var _default = Facebook;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Facebook, "Facebook", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/assets/Facebook.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/assets/Facebook.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();